import React, { useState, useEffect } from 'react';
import TR from './../../Trans';
import Button from '@mui/material/Button';
import sessionStore from '../../stores/session';
import environmentStore from '../../stores/environment';
import songbookSessionStore from '../../stores/songbookSession';
import muvikaAttrs from './../../attrs';

function ChooseLanguage(props) {

  const listLanguages = () => { 
    if (props.environment && muvikaAttrs.showChooseLang) {
      return props.environment.languages.map((language) =>
        <Button className="muvika-lang-button" key={language} variant="text" onClick={() => props.onLanguageChange(language)}>{language == "Finnish" ? TR.cm_lang_finnish : language}</Button>
      );
    }
  };

  return (
    <div style={{position: props.isBottom ? "absolute": "", bottom: props.isBottom ? "0" : "unset"}}>
      {listLanguages()}
    </div>
  );
}

export default ChooseLanguage;